<app-marine-insurance-card
  [cardTitle]="(isAirwayEntry ? 'SHIPMENT_DETAILS_AWB_NUMBER' : 'SHIPMENT_DETAILS_BL_NUMBER') | translate : { billNumber: billNumber }"
>
  <ng-container body>
    <div class="marine-insurance-quote-shipment-details-form" *ngIf="isShowForm">
      <p class="marine-insurance-quote-shipment-details-form-hint" *ngIf="!isAirwayEntry">
        {{ "COMPLETE_LAST_DETAILS_TO_FINALIZE_PURCHASE" | translate }}
      </p>

      <div class="row">
        <div class="col-12 col-xl-6">
          <date-picker
            id="dateTimeFrom"
            placeholder="LABELS.DEPARTURE_DATE"
            name="dateTimeFrom"
            label="LABELS.DEPARTURE_DATE"
            [fc]="formGroup.get('shippingDate')"
            [errors]="defaultErrors"
            [isShowDisabled]="formGroup.get('shippingDate').disabled"
          ></date-picker>
        </div>

        <div class="col-12 col-xl-6" *ngIf="!isAirwayEntry">
          <app-control-wrapper [control]="formGroup.get('typeOfShipment')" [errors]="defaultErrors">
            <label for="typeOfShipment" control-label>{{ "PACKING_TYPE" | translate }}</label>
            <ng-select
              id="typeOfShipment"
              class="custom"
              control-wrapper
              bindLabel="label"
              bindValue="id"
              [formControl]="formGroup.get('typeOfShipment')"
              [placeholder]="'FORM_PLACEHOLDER.SELECT' | translate"
              [items]="insuranceShipmentTypes"
              [clearable]="false"
            ></ng-select>
          </app-control-wrapper>
        </div>

        <div class="col-12 col-xl-6" *ngIf="!isAirwayEntry">
          <app-control-wrapper [control]="formGroup.get('vesselName')" [errors]="defaultErrors">
            <label for="vesselName" control-label>{{ vesselNameLabel | translate }}</label>
            <input
              class="form-control"
              id="vesselName"
              name="vesselName"
              type="text"
              maxlength="20"
              control-wrapper
              [formControl]="formGroup.get('vesselName')"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [mask]="'F*'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
              [placeholder]="'FORM_PLACEHOLDER.ENTER' | translate"
            />
          </app-control-wrapper>
        </div>

        <div class="col-12 col-xl-6">
          <app-control-wrapper [control]="formGroup.get('voyageNumber')" [errors]="defaultErrors">
            <label for="voyageNumber" control-label>{{ voyageNumberLabel | translate }}</label>
            <input
              class="form-control"
              id="voyageNumber"
              name="voyageNumber"
              type="text"
              maxlength="5"
              control-wrapper
              [formControl]="formGroup.get('voyageNumber')"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [mask]="'F*'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
              [placeholder]="'FORM_PLACEHOLDER.ENTER' | translate"
            />
          </app-control-wrapper>
        </div>
      </div>
    </div>

    <div class="marine-insurance-quote-shipment-details-view" *ngIf="!isShowForm">
      <div class="marine-insurance-quote-shipment-details-view-col">
        <div class="marine-insurance-quote-shipment-details-view-col-row">
          <div class="marine-insurance-quote-shipment-details-view-col-label">{{ "PACKING_TYPE" | translate }}</div>
          <div class="marine-insurance-quote-shipment-details-view-col-value">{{ typeOfShipmentValue | translate }}</div>
        </div>

        <div class="marine-insurance-quote-shipment-details-view-col-row">
          <div class="marine-insurance-quote-shipment-details-view-col-label">{{ "LABELS.DEPARTURE_DATE" | translate }}</div>
          <div class="marine-insurance-quote-shipment-details-view-col-value">{{ marineInsurance?.shippingDate | customDateByUtc }}</div>
        </div>
      </div>

      <div class="marine-insurance-quote-shipment-details-view-col">
        <div class="marine-insurance-quote-shipment-details-view-col-row">
          <div class="marine-insurance-quote-shipment-details-view-col-label">{{ vesselNameLabel | translate }}</div>
          <div class="marine-insurance-quote-shipment-details-view-col-value">{{ marineInsurance?.vesselName }}</div>
        </div>

        <div class="marine-insurance-quote-shipment-details-view-col-row">
          <div class="marine-insurance-quote-shipment-details-view-col-label">{{ voyageNumberLabel | translate }}</div>
          <div class="marine-insurance-quote-shipment-details-view-col-value">{{ marineInsurance?.voyageNumber }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</app-marine-insurance-card>
